import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  po: null,
  jastip: null
};

const listView = createSlice({
  name: 'listView',
  initialState,
  reducers: {
    saveListView(state, action) {
      const { key, view } = action.payload;
      state[key] = view;
    }
  }
});

export default listView.reducer;

export const { saveListView } = listView.actions;
